import React from 'react';

import { StyledPicture, StyledImage } from './style';
import type { BannerLayout } from '../../@types/Content';

type PictureInput = {
  imageAlt: string;
  imageSrcLarge: string;
  imageSrcMedium?: string;
  imageSrcSmall?: string;
  fullWidth: boolean;
  [key: string]: unknown;
  label: string;
  bannerLayout: BannerLayout;
};

export const Picture = ({
  imageAlt,
  imageSrcSmall,
  imageSrcMedium,
  imageSrcLarge,
  fullWidth,
  label,
  bannerLayout,
  ...ueImageProps
}: PictureInput) => {
  return (
    <StyledPicture
      data-testid="Banner__picture"
      {...ueImageProps}
      data-label={label}
      bannerLayout={bannerLayout}
      fullWidth={fullWidth}
    >
      <source data-testid="Banner__sourceSmall" srcSet={imageSrcSmall} media="(max-width: 767px)" />
      <source
        data-testid="Banner__sourceMedium"
        srcSet={imageSrcMedium}
        media="(min-width: 768px) and (max-width: 1023px)"
      />
      <source
        data-testid="Banner__sourceLarge"
        srcSet={imageSrcLarge}
        media="(min-width: 1024px)"
      />

      <StyledImage
        data-testid="Banner__image"
        src={imageSrcSmall}
        alt={imageAlt}
        fullWidth={fullWidth}
        bannerLayout={bannerLayout}
      />
    </StyledPicture>
  );
};

export default Picture;
